// 新增 修改公用
class taxCertificateEditCtrl {
    constructor($scope, logger, httpRequest, $state, $stateParams) {
        // 初始化表单数据
        const { saleId } = $stateParams
        $scope.isEdit = saleId || saleId === 0
        $scope.saleForm = {
            businessAddress: '',
            legalName: '',
            levyWay: '1',
            phone: '',
            registerAddress: '',
            registerDetailAddress: '',
            registerType: '',
            remark: '',
            saleBankAccount: {
                accountId: '',
                bank: '',
                bankAccount: '',
                isBasic: 0,
                remark: '',
                saleId: 0,
            },
            saleCreditCode: '',
            saleId: 0,
            saleName: '',
            taxDiskType: '2',
            taxplayerType: '1',
            platformCode: '',
            platformPassword: '',
            authCode: '',
            diskType: '1',
            companyProperty: '',
            ivatCollectServer: {
                diskPassword: '12345678',
                platformPassword: '',
                // serverAddress: 'https://127.0.0.1:8889',
                serverAddress: 'https://soap.szhtxx.com:8889',
            },
        }
        let oldPwd
        $scope.platformPassword = ''
        // 获取信息
        if ($scope.isEdit) {
            httpRequest.get_getSaleInfo(saleId).then((res) => {
                $scope.saleForm = $.extend({}, $scope.saleForm, res.data.value)
                $scope.saleForm.diskType = '1'
                if (!$scope.saleForm.ivatCollectServer) {
                    $scope.saleForm.ivatCollectServer = {
                        diskPassword: '12345678',
                        platformPassword: '',
                        // serverAddress: 'https://127.0.0.1:8889',
                        serverAddress: 'https://soap.szhtxx.com:8889',

                    }
                }
                oldPwd = $scope.saleForm.platformPassword
                $scope.platformPassword = oldPwd
                httpRequest.get_getProvince().then((res) => {
                    $scope.cityData = res.data.value
                    if ($scope.saleForm.sfdqDto) {
                        for (let i = 0; i < $scope.cityData.length; i++) {
                            if ($scope.saleForm.sfdqDto.sjsfdqDm == $scope.cityData[i].sfdqDm) {
                                $scope.defaultProvince = $scope.cityData[i]
                                for (let j = 0; j < $scope.defaultProvince.cityList.length; j++) {
                                    if ($scope.saleForm.sfdqDm == $scope.defaultProvince.cityList[j].sfdqDm) {
                                        $scope.defaultCity = $scope.defaultProvince.cityList[j]
                                    }
                                }
                            }
                        }
                    } else {
                        $scope.defaultProvince = $scope.cityData[0]
                        $scope.defaultCity = $scope.defaultProvince.cityList[0]
                    }
                })
            })
        }
        $scope.tabFlag = 0
        $scope.tabChage = function tabChage(v) {
            if (checkRules($scope.tabFlag)) {
                $scope.tabFlag = v
            }
        }
        httpRequest.get_getProvince().then((res) => {
            $scope.cityData = res.data.value
            $scope.defaultProvince = $scope.cityData[0]
            $scope.defaultCity = $scope.defaultProvince.cityList[0]
        })
        // 字典数据
        $scope.taxplayerTypeList = []
        $scope.taxDiskTypeList = []
        $scope.levyWayList = []
        $scope.bankList = []

        httpRequest.get_dictByTypeArr('["tax_disk_type","taxplayer_type","levy_way","disk_type","register_type"]').then((res) => {
            $scope.dictionary = res.data.value
            if (!$scope.isEdit) {
                $scope.saleForm.registerType = $scope.dictionary.register_type[0].enumCode
                $scope.saleForm.diskType = $scope.dictionary.disk_type[1].enumCode
            }
        })
        $scope.diskTypeChange = function diskTypeChange() {
            console.log($scope.saleForm)
            // if ($scope.saleForm.diskType == 1) {
            //     $scope.saleForm.ivatCollectServer.serverAddress = 'http://127.0.0.1:8889'
            // }
            // if ($scope.saleForm.diskType == 2) {
            //     $scope.saleForm.ivatCollectServer.serverAddress = ''
            //     $scope.saleForm.ivatCollectServer.diskPassword = '12345678'
            // }
            if ($scope.saleForm.diskType == 1) {
                $scope.saleForm.ivatCollectServer = {
                    diskPassword: '',
                    platformPassword: '',
                    // serverAddress: 'https://127.0.0.1:8889',
                    serverAddress: 'https://soap.szhtxx.com:8889',
                }
            }
            if ($scope.saleForm.diskType == 2) {
                $scope.saleForm.ivatCollectServer = {
                    diskPassword: '12345678',
                    platformPassword: '',
                    serverAddress: '',
                }
            }
        }
        // $scope.$watch('saleForm.diskType', function (newV) {
        //     if (newV == 1) $scope.saleForm.ivatCollectServer.serverAddress = 'http://127.0.0.1:8889'
        //     if (newV == 2) $scope.saleForm.ivatCollectServer.serverAddress = ''
        // })
        function addSaleInfo(vmform, code) {
            httpRequest.post_addSaleInfo(vmform, '新增税务证成功').then(() => {
                if (code == 'continue') {
                    $state.go('system.syssetting.taxCertificate.addTaxCertificate')
                    return
                }
                $state.go('system.syssetting.taxCertificate.list')
            })
        }
        function updateSaleInfo(vmform, code) {
            // const ret = formvalidateApi.run()
            // if (ret) {
            httpRequest.post_updateSaleInfo(vmform, '编辑税务证成功').then(() => {
                if (code == 'continue') {
                    $state.go('system.syssetting.taxCertificate.addTaxCertificate')
                    return
                }
                $state.go('system.syssetting.taxCertificate.list')
            })
            // }
        }

        $scope.submit = function (code) {
            // const ret = formvalidateApi.run()
            // if (!ret) {
            // return
            // }
            if (!checkRules($scope.tabFlag)) {
                return
            }
            $scope.saleForm.platformPassword = $scope.platformPassword
            // $scope.saleForm.registerAddress = $scope.defaultProvince.sfdqmc + $scope.defaultCity.sfdqmc + $scope.saleForm.registerDetailAddress;
            $scope.saleForm.sfdqDm = $scope.defaultCity.sfdqDm
            if ($scope.isEdit) {
                if ($scope.platformPassword === oldPwd) {
                    $scope.saleForm.platformPassword = ''
                }
                updateSaleInfo($scope.saleForm, code)
            } else {
                addSaleInfo($scope.saleForm, code)
            }
        }
        // 规则验证
        $scope.validateRules = {
            saleCreditCode: [
                {
                    erromsg: '必须为15位、17位、18位、20位和21位的数字或大写字母',
                    condition(value) {
                        // 规则
                        const regex = /(^[a-zA-Z0-9]{15}$)|(^[a-zA-Z0-9]{17,18}$)|(^[a-zA-Z0-9]{20,21}$)/
                        const result = regex.test(value)
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
        }
        function checkRules(v) {
            if (v == 0) {
                if (!$scope.saleForm.saleName) {
                    logger.logError('名称不允许为空')
                    return false
                }
                if (!/(^[a-zA-Z0-9]{15}$)|(^[a-zA-Z0-9]{17,18}$)|(^[a-zA-Z0-9]{20,21}$)/.test($scope.saleForm.saleCreditCode)) {
                    logger.logError('信用代码必须为15位、17位、18位、20位和21位的数字或大写字母')
                    return false
                }
                if (!$scope.defaultProvince || !$scope.defaultCity) {
                    logger.logError('省份市区不允许为空')
                    return false
                }
                if (!$scope.saleForm.registerAddress) {
                    logger.logError('注册地址不允许为空')
                    return false
                }
            } else if (v == 1) {
                if (!$scope.saleForm.saleBankAccount.bank) {
                    logger.logError('开户银行不允许为空')
                    return false
                }
                if (!$scope.saleForm.saleBankAccount.bankAccount) {
                    logger.logError('银行账号不允许为空')
                    return false
                }
            } else if (v == 2) {
                if (!$scope.saleForm.diskType) {
                    logger.logError('发票采集方式不允许为空')
                    return false
                }
            }
            return true
        }
        $scope.back = function back() {
            $scope.tabChage($scope.tabFlag - 1)
        }
        $scope.next = function next() {
            $scope.tabChage($scope.tabFlag + 1)
        }
        $scope.upperCase = function upperCase() {
            if ($scope.saleForm.saleCreditCode) {
                $scope.saleForm.saleCreditCode = $scope.saleForm.saleCreditCode.toUpperCase()
            }
        }
        // 返回
        $scope.cancel = function cancel() {
            // $scope.pageState.current = "query";
            $state.go('system.syssetting.taxCertificate.list')
            return false
        }
    }
}

taxCertificateEditCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', '$stateParams']
export default taxCertificateEditCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/taxcertificate/taxCertificateEditCtrl.js